// source: pbtypes/vehicle/health_monitor/fault_detectors.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.fault_detectors.BatteryCellVoltageImbalanceThresholds', null, global);
goog.exportSymbol('proto.fault_detectors.LastDockHeadingEstimateMismatched', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.repeatedFields_, null);
};
goog.inherits(proto.fault_detectors.BatteryCellVoltageImbalanceThresholds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.displayName = 'proto.fault_detectors.BatteryCellVoltageImbalanceThresholds';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fault_detectors.LastDockHeadingEstimateMismatched, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fault_detectors.LastDockHeadingEstimateMismatched.displayName = 'proto.fault_detectors.LastDockHeadingEstimateMismatched';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.toObject = function(opt_includeInstance) {
  return proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.toObject = function(includeInstance, msg) {
  var f, obj = {
cellVoltageImbalanceVoltageScheduleList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f,
cellVoltageImbalanceThresholdScheduleList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fault_detectors.BatteryCellVoltageImbalanceThresholds;
  return proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      reader.readPackableFloatInto(msg.getCellVoltageImbalanceVoltageScheduleList());
      break;
    case 2:
      reader.readPackableFloatInto(msg.getCellVoltageImbalanceThresholdScheduleList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCellVoltageImbalanceVoltageScheduleList();
  if (f.length > 0) {
    writer.writePackedFloat(
      1,
      f
    );
  }
  f = message.getCellVoltageImbalanceThresholdScheduleList();
  if (f.length > 0) {
    writer.writePackedFloat(
      2,
      f
    );
  }
};


/**
 * repeated float cell_voltage_imbalance_voltage_schedule = 1;
 * @return {!Array<number>}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.getCellVoltageImbalanceVoltageScheduleList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.setCellVoltageImbalanceVoltageScheduleList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.addCellVoltageImbalanceVoltageSchedule = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.clearCellVoltageImbalanceVoltageScheduleList = function() {
  return this.setCellVoltageImbalanceVoltageScheduleList([]);
};


/**
 * repeated float cell_voltage_imbalance_threshold_schedule = 2;
 * @return {!Array<number>}
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.getCellVoltageImbalanceThresholdScheduleList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.setCellVoltageImbalanceThresholdScheduleList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.addCellVoltageImbalanceThresholdSchedule = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fault_detectors.BatteryCellVoltageImbalanceThresholds} returns this
 */
proto.fault_detectors.BatteryCellVoltageImbalanceThresholds.prototype.clearCellVoltageImbalanceThresholdScheduleList = function() {
  return this.setCellVoltageImbalanceThresholdScheduleList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.toObject = function(opt_includeInstance) {
  return proto.fault_detectors.LastDockHeadingEstimateMismatched.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fault_detectors.LastDockHeadingEstimateMismatched} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.toObject = function(includeInstance, msg) {
  var f, obj = {
siteHeading: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
headingError: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fault_detectors.LastDockHeadingEstimateMismatched}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fault_detectors.LastDockHeadingEstimateMismatched;
  return proto.fault_detectors.LastDockHeadingEstimateMismatched.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fault_detectors.LastDockHeadingEstimateMismatched} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fault_detectors.LastDockHeadingEstimateMismatched}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSiteHeading(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fault_detectors.LastDockHeadingEstimateMismatched.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fault_detectors.LastDockHeadingEstimateMismatched} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteHeading();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getHeadingError();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional float site_heading = 2;
 * @return {number}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.getSiteHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fault_detectors.LastDockHeadingEstimateMismatched} returns this
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.setSiteHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float heading_error = 3;
 * @return {number}
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.getHeadingError = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fault_detectors.LastDockHeadingEstimateMismatched} returns this
 */
proto.fault_detectors.LastDockHeadingEstimateMismatched.prototype.setHeadingError = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


goog.object.extend(exports, proto.fault_detectors);
